const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Forest Reach",

  webfeedDebuggerWebsiteUrl: "https://forestreach.avid.com.au/masterplan/",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
